import './../common.js';
import Vue from "vue";
import Vuex from "vuex";
import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(Vuex);
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

// MODULES
import "./../modules/utilities/copyCode";

// INIT
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
    
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
    
    if (document.getElementById("banner")) {
        new Vue({
            el: "#banner",
            components: {
                "banner": () => import("./../vuejs/components/Banner.vue"),
            },
        });
    }

    if (document.getElementById("slide-product")) {
        new Vue({
            el: "#slide-product",
            components: {
                "slide-product": () => import("./../vuejs/components/SlideProduct.vue"),
            },
        });
    }

    if (document.getElementById("wizard-sponsorship-fo")) {
        new Vue({
            el: "#wizard-sponsorship-fo",
            components: {
                "wizard-sponsorship-fo": () => import("./../vuejs/components/Wizards/WizardSponsorshipFo.vue"),
            },
        });
    }
});
